<template>
  <div class="app-container" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="薪资汇总" name="one" style="">
        <xinziHuiZong v-if="activeName=='one'" ref="monthHeSuan" @switchToDetails="handleSwitchToDetails"></xinziHuiZong>
      </el-tab-pane>
      <el-tab-pane label="薪资明细" name="two">
        <xinziMingXi v-if="activeName=='two'" ref="hesuanmingxi" :detailId="detailId"></xinziMingXi>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import xinziHuiZong from '@/views/newTMS/costExpense/driverXinZi/xinziHuiZong.vue'
import xinziMingXi from '@/views/newTMS/costExpense/driverXinZi/xinziMingXi.vue'
export default {
  components: {
    xinziHuiZong, xinziMingXi
  },
  data () {
    return {
      activeName: 'one',
      detailId: null
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  },
  methods: {
    handleSwitchToDetails (id) { // 新增
      this.detailId = id
      this.activeName = 'two'
    },
    handleClick (tab) { // 新增
      if (tab.name === 'two' && !this.detailId && this.$refs.hesuanmingxi) {
        this.$refs.hesuanmingxi.loadDefaultData()
      }
      this.detailId = null // 重置，下次点击标签时重新加载默认数据
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
